import {
	CLEAR_PROVIDER_ATTR_GLOBAL,
	EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN,
	EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_FILTERS,
	SET_PROVIDER_ATTR_GLOBAL_FILTERS_SUCCESS,
	SET_PROVIDER_ATTR_INDIVIDUAL,
	SET_PROVIDER_ATTR_INDIVIDUAL_SUCCESS
} from 'constants/ActionsTypes'

export interface valueState {
	providerAttrList: any
	providerAttrIndividualAccept: any
	providerAttrGlobalAssignConfirmed: any
	providerAttrEdit: any
	providerAttrGlobalAssigned: any
	providerAttrPagination: any
}

const initialState = {
	providerAttrList: null,
	providerAttrIndividualAccept: null,
	providerAttrGlobalAssignConfirmed: null,
	providerAttrEdit: null,
	providerAttrGlobalAssigned: null,
	providerAttrPagination: null
}

function rootReducer(state: valueState = initialState, action: any) {
	switch (action.type) {
		case SET_PROVIDER_ATTR_GLOBAL_FILTERS:
			return { ...state, providerAttrList: null }
		case SET_PROVIDER_ATTR_GLOBAL_FILTERS_SUCCESS:
			return { ...state, providerAttrList: action.payload }
		case SET_PROVIDER_ATTR_INDIVIDUAL:
			return { ...state, providerAttrIndividualAccept: null }
		case SET_PROVIDER_ATTR_INDIVIDUAL_SUCCESS:
			return { ...state, providerAttrIndividualAccept: action.payload }
		case SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM:
			return { ...state, providerAttrGlobalAssignConfirmed: null }
		case SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS:
			return { ...state, providerAttrGlobalAssignConfirmed: action.payload }
		case EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN:
			return { ...state, providerAttrEdit: null }
		case EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS:
			return { ...state, providerAttrEdit: action.payload }
		case SET_PROVIDER_ATTR_GLOBAL_ASSIGN:
			return { ...state, providerAttrGlobalAssigned: null }
		case SET_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS:
			return { ...state, providerAttrGlobalAssigned: action.payload }
		case SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION:
			return { ...state, providerAttrPagination: null }
		case SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS:
			return { ...state, providerAttrPagination: action.payload }
		case CLEAR_PROVIDER_ATTR_GLOBAL:
			return { ...state, providerAttrList: null, providerAttrPagination: null }
		default:
			return state
	}
}

export default rootReducer
